/* eslint-disable */
// @ts-ignore
if (typeof global === 'undefined') {
  // https://github.com/aws/aws-amplify/issues/678 fix: can be removed after updating aws package
  var global = window;
  window.global = global;
}
